'use client';

import React from 'react';

import Badge, { BadgeStyle } from '@cineamo/ui/src/badge/Badge';
import BadgeList from '@cineamo/ui/src/badge/BadgeList';

// `Badge` always wires up an `onClick` handler internally (it calls through to `onBadgeClick`,
// which no-ops when unset) even when the caller never asked for interactivity. A `<div
// onClick={fn}>` rendered straight from a Server Component throws "Event handlers cannot be
// passed to Client Component props" — the function reference can't cross the RSC boundary. Badge
// and BadgeList live in `packages/ui` and are out of scope to change here, so every Badge-based
// chip on the deals pages is isolated behind this Client Component instead.

type ValidTodayBadgeProps = {
    label: string;
    className?: string;
};

export function ValidTodayBadge(props: ValidTodayBadgeProps): React.JSX.Element {
    return (
        <Badge
            className={props.className}
            name={props.label}
            badgeStyle={BadgeStyle.filter12}
            bgColor="bg-[var(--primary-color)]"
            textColor="text-[var(--on-primary-color)]"
        />
    );
}

type DealChipListProps = {
    labels: string[];
};

export function DealChipList(props: DealChipListProps): React.JSX.Element | null {
    if (props.labels.length === 0) {
        return null;
    }
    return (
        <BadgeList
            // `BadgeList`'s `string[]` shorthand treats the string itself as `href` (it becomes a
            // broken `<a href="nur an der Kasse">`) — these are plain display labels, so pass
            // `{ id, name }` objects (no `href`) to keep them non-interactive `<div>`s.
            badges={props.labels.map((label, index) => ({ id: `${index}-${label}`, name: label }))}
            badgeStyle={BadgeStyle.filter}
            badgeBgColor="bg-[rgba(var(--on-surface-color-rgb),0.12)]"
            badgeTextColor="text-[var(--on-surface-color)]"
        />
    );
}
